//==================================================================//
//======================= IMPORTS API ==============================//
//==================================================================//

import ERP from "../ERP.mjs";
import View from "../View.mjs";
import Schema from "../Schema.mjs";

//==================================================================//
//======================= IMPORT UTILS =============================//
//==================================================================//

import UtilArray from "@/utils/UtilArray.mjs";
import UtilSequence from "@/utils/UtilSequence.mjs";

//==================================================================//
//========================= METHODS ================================//
//==================================================================//

export default {

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewJobs(){

        let jobs;

        try{

            //==================================================================//
            //========================= Pega Jobs ==============================//
            //==================================================================//

            jobs = await ERP.getManyWithView(View.JOB_ALTERAR_COORDENADOR);

        }catch(e){

            console.log(e);
            return jobs;

        }

        return jobs;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewCoordenadoresDeContratos(){

        let jobCoordenadoresDeContratos;

        try{

            //==================================================================//
            //================ Pega Job Coordenadores de Contratos ==============//
            //==================================================================//

            jobCoordenadoresDeContratos = await ERP.getManyWithView(View.JOB_ALTERAR_COORDENADOR_COORDENADORES_DE_CONTRATOS);

        }catch(e){

            console.log(e);
            return jobCoordenadoresDeContratos;

        }

        return jobCoordenadoresDeContratos;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async alteraCoordenadorDoJob(jobID = "", coordenadorDeContratosID = ""){

        let jobAlterado;

        try{

            //==================================================================//
            //============== PEGA COORDENADOR DE CONTRATOS =====================//
            //==================================================================//

            let coordenadorDeContratos = await ERP.getOneById(Schema.COLABORADOR, coordenadorDeContratosID);
            if(coordenadorDeContratos?.status != 200){
                throw coordenadorDeContratos;
            }

            let coordenadorDeContratosUserID = coordenadorDeContratos.data?.user?.userId;

            //==================================================================//
            //====================== PEGA O JOB ATUAL ===========================//
            //==================================================================//

            let job = await ERP.getOneById(Schema.JOB, jobID);
            if(job?.status != 200){
                throw job;
            }

            //==================================================================//
            //=================== ALTERA COORDENADOR DO JOB ====================//
            //==================================================================//

            let jobOwnersIDs = job.data?.owners?.map((owner) => owner?.userId) || [];

            jobAlterado = await ERP.patchOne(Schema.JOB, {
                id: jobID,
                collaboradorId: coordenadorDeContratosID,
                owners: UtilArray.unique([...jobOwnersIDs, coordenadorDeContratosUserID]),
            });

            if(jobAlterado?.status != 200){
                throw jobAlterado;
            }

        }catch(e){

            console.log(e);
            return jobAlterado;

        }

        return jobAlterado;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async alteraCoordenadorDosJobs(jobsIDs = [], coordenadorDeContratosID = ""){

        let jobsAlterados;

        try{

            //==================================================================//
            //============== PEGA COORDENADOR DE CONTRATOS =====================//
            //==================================================================//

            let coordenadorDeContratos = await ERP.getOneById(Schema.COLABORADOR, coordenadorDeContratosID);
            if(coordenadorDeContratos?.status != 200){
                throw coordenadorDeContratos;
            }

            let coordenadorDeContratosUserID = coordenadorDeContratos.data?.user?.userId;

            //==================================================================//
            //============= ALTERA COORDENADOR DE VÁRIOS JOBS ==================//
            //==================================================================//

            jobsAlterados = await UtilSequence.each({
                list: jobsIDs,
                callback: async (jobID) => {

                    let job = await ERP.getOneById(Schema.JOB, jobID);
                    if(job?.status != 200){
                        throw job;
                    }

                    let jobOwnersIDs = job.data?.owners?.map((owner) => owner?.userId) || [];

                    let jobAlterado = await ERP.patchOne(Schema.JOB, {
                        id: jobID,
                        collaboradorId: coordenadorDeContratosID,
                        owners: UtilArray.unique([...jobOwnersIDs, coordenadorDeContratosUserID]),
                    });

                    if(jobAlterado?.status != 200){
                        throw jobAlterado;
                    }

                    return {
                        status: jobAlterado?.status || 200,
                        data: jobAlterado?.data || [],
                    };

                },
            });

            console.log(jobsAlterados);

        }catch(e){

            console.log(e);
            return jobsAlterados;

        }

        return jobsAlterados;

    },

}
